{{#if isPipelined}}
virtual function int to_index();
  return {{ idVariable.identifier }};
endfunction
{{/if}}
